import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { svgArrow } from '../utils/icons';
import Action from './Action';

const StyledChapterNavigation = styled.div`
  margin: 1rem 0;

  @media screen and (max-width: 64rem) {
    margin: 1rem 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const NavigationSpacer = styled.div`
  display: flex;

  a {
    margin: 0 1rem;
  }
`;

function getPreviousChapter(parts, currentPart, currentChapter, bookId) {
  const currentPartIndex = parts.findIndex(p => p.key === currentPart);
  const currentPartData = parts[currentPartIndex];
  const currentChapterIndex = currentPartData.chapters.findIndex(
    c => c.key === currentChapter
  );
  const prevPartIndex = currentPartIndex - 1;

  if (prevPartIndex < 0 && currentChapterIndex === 0) {
    return {
      url: '#',
      label: '#',
      hide: true
    };
  }

  if (currentChapterIndex > 0) {
    const previousChapterSlug =
      currentPartData.chapters[currentChapterIndex - 1].slug;

    return {
      url: `/bok/${bookId}/kapittel/${previousChapterSlug}`,
      label: 'Forrige kapittel',
      hide: false
    };
  } else if (currentChapterIndex === 0) {
    const prevChapters = parts[prevPartIndex].chapters;
    const prevLastChapter = prevChapters[prevChapters.length - 1];

    return {
      url: `/bok/${bookId}/kapittel/${prevLastChapter.slug}`,
      label: 'Forrige del',
      hide: false
    };
  }
}

function getNextChapter(parts, currentPart, currentChapter, bookId) {
  const currentPartIndex = parts.findIndex(p => p.key === currentPart);
  const currentPartData = parts[currentPartIndex];
  const currentChapterIndex = currentPartData.chapters.findIndex(
    c => c.key === currentChapter
  );
  const isOnLastPart = currentPartIndex === parts.length - 1;
  const isOnLastChapter =
    currentChapterIndex === currentPartData.chapters.length - 1;

  if (isOnLastChapter && isOnLastPart) {
    return { url: `/bok/${bookId}`, label: 'Ferdig' };
  } else if (isOnLastChapter) {
    return {
      url: parts[currentPartIndex + 1].chapters[0].slug,
      label: 'Neste del'
    };
  }

  return {
    url: currentPartData.chapters[currentChapterIndex + 1].slug,
    label: 'Neste kapittel'
  };
}

const ChapterNavigation = ({ parts, currentPart, currentChapter, bookId }) => {
  const nextData = getNextChapter(parts, currentPart, currentChapter, bookId);
  const prevData = getPreviousChapter(
    parts,
    currentPart,
    currentChapter,
    bookId
  );

  return (
    <StyledChapterNavigation>
      <NavigationSpacer>
        {!prevData.hide && (
          <Action
            to={prevData.url}
            icon={svgArrow}
            iconPosition="left"
            rotateIcon={true}
          >
            {prevData.label}
          </Action>
        )}
        <Action to={nextData.url} icon={svgArrow} iconPosition="right">
          {nextData.label}
        </Action>
      </NavigationSpacer>
    </StyledChapterNavigation>
  );
};

const chapterType = PropTypes.shape({
  key: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired
});

const partType = PropTypes.shape({
  key: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  chapters: PropTypes.arrayOf(chapterType).isRequired
});

ChapterNavigation.propTypes = {
  parts: PropTypes.arrayOf(partType.isRequired).isRequired,
  currentPart: PropTypes.number.isRequired,
  currentChapter: PropTypes.number.isRequired,
  bookId: PropTypes.number.isRequired
};

export default ChapterNavigation;



// WEBPACK FOOTER //
// ./src/components/ChapterNavigation.js